/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileStatusEnum } from './FileStatusEnum';
import {
    FileStatusEnumFromJSON,
    FileStatusEnumFromJSONTyped,
    FileStatusEnumToJSON,
    FileStatusEnumToJSONTyped,
} from './FileStatusEnum';

/**
 * Serializer for the EventAttachment model.
 * @export
 * @interface EventFileCreate
 */
export interface EventFileCreate {
    /**
     * 
     * @type {string}
     * @memberof EventFileCreate
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof EventFileCreate
     */
    owner?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventFileCreate
     */
    event: string;
    /**
     * 
     * @type {number}
     * @memberof EventFileCreate
     */
    uploadedBy?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventFileCreate
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EventFileCreate
     */
    file: string;
    /**
     * Creates upload URL based on filename field.
     * @type {string}
     * @memberof EventFileCreate
     */
    readonly uploadUrl: string;
    /**
     * Returns filename to API.
     * @type {string}
     * @memberof EventFileCreate
     */
    readonly filename: string;
    /**
     * 
     * @type {FileStatusEnum}
     * @memberof EventFileCreate
     */
    fileStatus?: FileStatusEnum;
}



/**
 * Check if a given object implements the EventFileCreate interface.
 */
export function instanceOfEventFileCreate(value: object): value is EventFileCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('file' in value) || value['file'] === undefined) return false;
    if ((!('uploadUrl' in (value as Record<string, any>)) && !('upload_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadUrl'] === undefined && (value as Record<string, any>)['upload_url'] === undefined)) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    return true;
}

export function EventFileCreateFromJSON(json: any): EventFileCreate {
    return EventFileCreateFromJSONTyped(json, false);
}

export function EventFileCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventFileCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'event': json['event'],
        'uploadedBy': json['uploaded_by'] === undefined ? undefined : json['uploaded_by'] === null ? null : json['uploaded_by'],
        'description': json['description'] == null ? undefined : json['description'],
        'file': json['file'],
        'uploadUrl': json['upload_url'],
        'filename': json['filename'],
        'fileStatus': json['file_status'] == null ? undefined : FileStatusEnumFromJSON(json['file_status']),
    };
}

export function EventFileCreateToJSON(json: any): EventFileCreate {
    return EventFileCreateToJSONTyped(json, false);
}

export function EventFileCreateToJSONTyped(value?: Omit<EventFileCreate, 'id'|'uploadUrl'|'filename'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'event': value['event'],
        'uploaded_by': value['uploadedBy'],
        'description': value['description'],
        'file': value['file'],
        'file_status': FileStatusEnumToJSON(value['fileStatus']),
    };
}

